import { render, staticRenderFns } from "./Inventoryofcurrentassets.vue?vue&type=template&id=072318dc&"
import script from "./Inventoryofcurrentassets.vue?vue&type=script&lang=js&"
export * from "./Inventoryofcurrentassets.vue?vue&type=script&lang=js&"
import style0 from "./Inventoryofcurrentassets.vue?vue&type=style&index=0&id=072318dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports